import styled from 'styled-components';
import { ERROR_RED, ERROR_RED_LIGHT, SUCCESS_GREEN, SUCCESS_GREEN_DARK, TEXT_SECONDARY } from '../../../constants/colors';

export const FeedbackButtons = styled.div`
  display: flex;
  gap: 6px;
  margin-top: 10px;
  opacity: 1;
`;

export const FeedbackButtons__Btn = styled.button<{ $selected: boolean; $isPositive?: boolean }>`
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 20px;
  padding: 6px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: ${TEXT_SECONDARY};
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

  &:hover:not(:disabled) {
    transform: scale(1.08) translateY(-1px);
    ${props => !props.$selected && props.$isPositive && `
      box-shadow: 0 4px 12px rgba(34, 197, 94, 0.2);
      background: rgba(240, 253, 244, 1);
      color: ${SUCCESS_GREEN};
    `}
    ${props => !props.$selected && !props.$isPositive && `
      box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);
      background: rgba(254, 242, 242, 1);
      color: ${ERROR_RED_LIGHT};
    `}
  }

  ${props => props.$selected && props.$isPositive && `
    background: linear-gradient(135deg, ${SUCCESS_GREEN_DARK} 0%, ${SUCCESS_GREEN} 100%);
    color: #FFFFFF;
    cursor: default;
    transform: scale(1.05);
    box-shadow: 0 4px 16px rgba(34, 197, 94, 0.3);
  `}

  ${props => props.$selected && !props.$isPositive && `
    background: linear-gradient(135deg, ${ERROR_RED} 0%, ${ERROR_RED_LIGHT} 100%);
    color: #FFFFFF;
    cursor: default;
    transform: scale(1.05);
    box-shadow: 0 4px 16px rgba(239, 68, 68, 0.3);
  `}

  &:active:not(:disabled) {
    transform: scale(0.95);
  }

  &:disabled {
    cursor: default;
  }
`;
